import {useQueryResponseLoading} from '../../core/QueryResponseProvider'

const ListLoading = () => {
  const isLoading = useQueryResponseLoading()
  return (
    <>
      {isLoading && (
        <div className='d-flex justify-content-center py-10'>
          <div className='spinner-border text-primary' role='status'>
            <span className='visually-hidden'>Loading...</span>
          </div>
        </div>
      )}
    </>
  )
}

export {ListLoading}

